/**
 * Root state for the entire application
 */
export const getDefaultState = () => {
  return {
    accessToken: null,
    refreshToken: null,
    user: {},
    userRoles: [],
    sidebarOpen: true,
    ports: {
      loaded: false,
      data: []
    }
  };
};

const state = getDefaultState();

export default state;
